import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ac1429a2")

_pushScopeId("data-v-ac1429a2")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "PaymentType__title" }, "Кем будет производиться оплата", -1)
const _hoisted_2 = { class: "PaymentType__options" }
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("circle", {
    class: "option__circle",
    cx: "7",
    cy: "7",
    r: "5",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createVNode("circle", {
    class: "option__border",
    cx: "7",
    cy: "7",
    r: "6.5",
    stroke: "currentColor"
  })
], -1)
const _hoisted_4 = { class: "option__name" }
const _hoisted_5 = {
  key: 0,
  class: "PaymentType__alert"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["PaymentType", { disabled: _ctx.disabled }]
  }, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PAYMENT_TYPE_OPTIONS, (payment_type) => {
        return (_openBlock(), _createBlock("div", {
          key: payment_type.id,
          class: ["options__option", {
                    'option--selected': _ctx.isOptionSelected(payment_type), 
                    'option--disabled': _ctx.isOptionDisabled(payment_type),
                }],
          onClick: ($event: any) => (_ctx.onOptionSelect(payment_type))
        }, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            (payment_type.value === 1 && Boolean(_ctx.senderCompanyName))
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(payment_type.name) + " (" + _toDisplayString(_ctx.senderCompanyName) + ") ", 1)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(payment_type.name), 1)
                ], 64))
          ])
        ], 10, ["onClick"]))
      }), 128))
    ]),
    (!_ctx.payersLength)
      ? (_openBlock(), _createBlock("div", _hoisted_5, " Для оплаты третьим лицом или плательщиком обратитесь к вашему менеджеру "))
      : _createCommentVNode("", true)
  ], 2))
})